var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIndefinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 5.33325H28V7.99992H17.3333V5.33325ZM17.3333 14.6666H28V17.3333H17.3333V14.6666ZM17.3333 23.9999H28V26.6666H17.3333V23.9999ZM8.66665 25.3333C7.19389 25.3333 5.99998 24.1394 5.99998 22.6666C5.99998 21.1938 7.19389 19.9999 8.66665 19.9999C10.1394 19.9999 11.3333 21.1938 11.3333 22.6666C11.3333 24.1394 10.1394 25.3333 8.66665 25.3333ZM8.66665 27.9999C11.6122 27.9999 14 25.6121 14 22.6666C14 19.7211 11.6122 17.3333 8.66665 17.3333C5.72113 17.3333 3.33331 19.7211 3.33331 22.6666C3.33331 25.6121 5.72113 27.9999 8.66665 27.9999ZM6.66665 7.99992V11.9999H10.6666V7.99992H6.66665ZM3.99998 5.33325H13.3333V14.6666H3.99998V5.33325Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIndefinite);
export default __webpack_public_path__ + "static/media/list-indefinite.8e188c98671663ab0bdde50b1ca9625a.svg";
export { ForwardRef as ReactComponent };